// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__2ONxQ","projectList":"Portfolio_projectList__CZ3uw"};